<div class="tablot-map-shell">
  <div class="map-city-search" (keydown)="onCitySearchKeydown($event)">
    <div class="city-search-field">
      <i class="pi pi-search"></i>
      <input
        type="text"
        placeholder="Rechercher une ville…"
        autocomplete="off"
        [value]="citySearchQuery"
        (input)="onCitySearchInput($any($event.target).value)"
        (focus)="onCitySearchFocus()"
        (blur)="onCitySearchBlur()"
      />
      @if (citySearchLoading) {
        <i class="pi pi-spin pi-spinner"></i>
      } @else if (citySearchQuery) {
        <button
          type="button"
          class="city-search-clear"
          title="Effacer"
          (mousedown)="clearCitySearch($event)"
        >
          <i class="pi pi-times"></i>
        </button>
      }
    </div>
    @if (citySearchOpen) {
      <ul class="city-search-results">
        @for (city of citySearchResults; track $index) {
          <li
            [class.is-active]="$index === citySearchActiveIndex"
            (mousedown)="selectCity(city, $event)"
            (mouseenter)="citySearchActiveIndex = $index"
          >
            <span class="city-name">{{ city.name }}</span>
            @if (city.context) {
              <span class="city-context">{{ city.context }}</span>
            }
          </li>
        }
      </ul>
    }
  </div>

  @if (tours.length > 0 || groupLegendItems.length > 0) {
    <div class="map-legend">
      @if (groupLegendItems.length > 0) {
        <div class="legend-section-header">
          <span class="legend-section-label">Groupes</span>
          <button
            type="button"
            class="legend-all-btn"
            (click)="toggleAllGroups()"
            [title]="allGroupsHidden ? 'Tout afficher' : 'Tout masquer'"
          >
            {{ allGroupsHidden ? 'Tout afficher' : 'Tout masquer' }}
          </button>
        </div>
        @for (item of groupLegendItems; track item.name) {
          <div class="legend-item-row">
            <button
              type="button"
              class="legend-item legend-item-toggle"
              [class.legend-item--hidden]="isGroupHidden(item.name)"
              (click)="toggleGroup(item.name)"
              [title]="
                isGroupHidden(item.name)
                  ? 'Afficher ' + item.name
                  : 'Masquer ' + item.name
              "
            >
              <span
                class="legend-dot"
                [style.background]="
                  isGroupHidden(item.name) ? 'transparent' : item.color
                "
                [style.border]="'2px solid ' + item.color"
              ></span>
              <span>{{ item.name }}</span>
            </button>
            @if (item.singlePoint; as singlePoint) {
              <button
                type="button"
                class="legend-focus-btn"
                [title]="
                  singlePoint.affairId != null
                    ? 'Centrer la carte et charger les créneaux'
                    : 'Centrer la carte sur ce point'
                "
                (click)="focusGroupPoint(singlePoint, $event)"
              >
                <i class="pi pi-map-marker"></i>
              </button>
            }
          </div>
        }
      }
      @if (tours.length > 0) {
        <div class="legend-section-label">Tournées</div>
        @for (item of tourLegendItems; track item.name) {
          <div class="legend-item">
            <span
              class="legend-dot"
              [style.background]="item.color"
              [style.borderColor]="item.color"
            ></span>
            <span>{{ item.name }}</span>
          </div>
        }
      }
    </div>
  }

  <div #mapContainer class="map-canvas"></div>
</div>
